// extracted by mini-css-extract-plugin
export var form = "prompt-module--form--e7c96";
export var msg = "prompt-module--msg--3d248";